var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Theme from 'Theme';
import cxs from 'cxs/component';
class IconosApp extends Component {
    render() {
        const _a = this.props, { name } = _a, props = __rest(_a, ["name"]);
        return React.createElement(StyledIcon, Object.assign({}, props), name);
    }
}
export default IconosApp;
const StyledIcon = cxs('div')(({ size, color, hover }) => ({
    display: 'inline-block',
    fontFamily: 'IconosApp',
    fontSize: size ? size + 'px' : Theme.fontSize.big,
    textTransform: 'initial',
    lineHeight: 1,
    padding: Theme.size.space[1],
    ':hover': {
        color: hover ? hover : Theme.color.primary
    },
    color: color ? color : Theme.color.secondary
}));
StyledIcon.propTypes = {
    size: PropTypes.number
};
export const Icono = {
    Abanico: 'abanico',
    Atraccion: 'atraccion',
    Autobus: 'autobus',
    Autocaravana: 'auto-caravana',
    Avion: 'avion',
    Barco: 'barco',
    Bicicleta: 'bicicleta',
    Buceo: 'buceo',
    Bus: 'bus',
    BusParada: 'busParada',
    BusTuristico: 'busTuristico',
    Castillo: 'castillo',
    Catedral: 'catedral',
    Delfines: 'delfines',
    Excursion: 'excursion',
    Elefante: 'elefante',
    Esqui: 'esqui',
    Ferry: 'ferry',
    Funcion: 'funcion',
    Funicular: 'funicular',
    Globo: 'globo',
    Hamaca: 'hamaca',
    Helicoptero: 'helicopero',
    HopOnOff: 'hopOnOff',
    IdaVuelta: 'idavuelta',
    Lancha: 'lancha',
    Moto: 'moto',
    MotoAgua: 'motoAgua',
    Museo: 'museo',
    Panoramica: 'panoramica',
    ParadaBus: 'paradaBus',
    ParadaTren: 'paradaTren',
    ParqueAtracciones: 'parqueAtracciones',
    Patin: 'patin',
    Piragua: 'piragua',
    Piscina: 'piscina',
    Ruta: 'ruta',
    Segway: 'segway',
    Senderismo: 'senderismo',
    Submarino: 'submarino',
    Telesilla: 'telesilla',
    Ticket: 'ticket',
    Tienda: 'tienda',
    Tiovivo: 'tiovivo',
    Tranvia: 'tranvia',
    Trenecito: 'trenecito',
    TrenParada: 'trenParada',
};
export const Iconos = Object.keys(Icono); /*.map(value => {
  console.log('value: ', value)
  return value
})*/



//////////////////
// WEBPACK FOOTER
// ./src/elements/IconosApp.tsx
// module id = 60
// module chunks = 0